// extracted by mini-css-extract-plugin
module.exports = {"img":"Icon_img__3u_4a","svg":"Icon_svg__16ORz"};